import React from 'react';
import { Pill } from '@/components/ui/pill';

/**
 * ScorePill - Governed Semantic Score Display
 * 
 * Enforces strict color mapping based on Score Logic:
 * High (>=80) or "GREEN" -> Success (Green)
 * Med (>=50) or "YELLOW" -> Warning (Amber)
 * Low (<50) or "RED" -> Destructive (Red)
 * 
 * @param {string|number} score - The numeric score (0-100) or semantic tag (GREEN/YELLOW/RED).
 * @param {string} className - Optional overrides.
 */
export function ScorePill({ score, className }) {
    let variant = "outline";
    let label = "N/A";

    const normalized = String(score || '').toUpperCase();

    // 1. Semantic String Match (Backend Legacy)
    if (normalized === "GREEN") {
        variant = "success";
        label = "HIGH";
    } else if (normalized === "YELLOW") {
        variant = "warning";
        label = "MED";
    } else if (normalized === "RED") {
        variant = "destructive";
        label = "LOW";
    }
    // 2. Numeric Range Match
    else {
        const num = parseInt(score, 10);
        if (!isNaN(num)) {
            label = `${num}%`;
            if (num >= 80) variant = "success";
            else if (num >= 50) variant = "warning";
            else variant = "destructive";
        }
    }

    // Fallback for null/undefined -> "N/A" with outline
    if (!score && score !== 0) {
        variant = "outline";
        label = "N/A";
    }

    return (
        <Pill variant={variant} className={className}>
            {label}
        </Pill>
    );
}
